import { CJAtelier } from 'types/cj';

export function getAllPendingEphemeralGroups(
  ateliers: CJAtelier[],
): Array<{ id: string; elevesIds: string[] }> {
  const pendingGroupsMap = new Map<
    string,
    { id: string; elevesIds: string[] }
  >();

  ateliers.forEach(atelier => {
    (atelier.pendingEphemeralGroups || []).forEach(peg => {
      pendingGroupsMap.set(peg.id, peg);
    });
  });

  return Array.from(pendingGroupsMap.values());
}
